import { useCallback, useEffect, useState, useRef } from "react";
import TableView from "../components/TableView";
import MasterableAction from "../generatedTableActions/MasterTableAction";
import Button from "../components/Button";
import Badge from "../components/Badge";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store";
import useSearchApi from "../customHooks/useSearchApi";
import { toast } from "react-toastify";
import TableSkeleton from "../components/TableSkeleton";
import { TTableProps } from "../types/TableView";
import TableLoader from "../utils/Loaders/tableLoader";
import { useNavigate } from "react-router-dom";
import { TOptionType } from "../types/CustomSelect";
import { getRegion } from "../app/request/regionRequest";
import { ActionCells } from "../components/ActionCells";
import { toAbsoluteUrl } from "../_metronic/helpers";
import BrandFilter from "../components/Filters/BrandFilter";
import { addMaster, getMaster } from "../generatedRequest/master";
import MasterList from "../generatedTableList/MasterList";

import {
  setCurrentPage,
  setPerPage,
  setLoading,
  setMaster,
  setSearchTerm,
  setTotalPage,
  setSortBy,
  setSortColumn,
  setTotalCount
} from "../generatedSlice/masterSlice"; 
import MasterTableAction from "../generatedTableActions/MasterTableAction";
import MasterFormModal from "../generatedFormModal/MasterFormModal";

const actions: string[] = ["Manually"];

const MasterPage = () => {
  const dispatch = useDispatch();
  
 
  
  const [initload, setInitload] = useState(true);
  const [filterloading, setFilterLoading] = useState(false);
  const [addMasterModel, setAddMasterModel] = useState(false);
  const [brandFilter, setBrandFilter]: any = useState('');
  // Ref to track if API call is in progress
  const apiCallInProgress = useRef(false);

  const {
    data,
    perPage,
    currentPage,
    totalPage,
    searchTerm,
    loading,
    sortBy,
    sortColumn,
    rerender1,
    totalCount

  } = useSelector((state: RootState) => state.master); 

  // Handle sorting
  const handleSort = useCallback((columnName: string) => {
    let newSortBy = 'asc';
    
    if (sortColumn === columnName && sortBy === 'asc') {
      newSortBy = 'desc';
    }
    
    dispatch(setSortColumn(columnName));
    dispatch(setSortBy(newSortBy));
    dispatch(setCurrentPage(1)); // Reset to first page when sorting
  }, [sortColumn, sortBy, dispatch]);

  // Sort icon component
  const SortIcon = ({ columnName }: { columnName: string }) => {
    if (sortColumn !== columnName) {
      return (
        <span style={{ marginLeft: '15px', opacity: 0.5 }}>
          ↕️
        </span>
      );
    }
    
    return (
      <span style={{ marginLeft: '5px' }}>
        {sortBy === 'asc' ? '↕️' : '↕️'}
      </span>
    );
  };

  const columns = [
    {
      name: "Keyword",
      renderHeader: (rows: any) => (
        <>
          <b style={{ paddingLeft: '8px' }}>Keyword</b>
        </>
      ),
      renderCell: (row: any) => (
        <>
          {row && (
            <div style={{ paddingLeft: '8px', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {row.keyword}
            </div>
          )}
        </>
      )
    },
    {
      name: "Master Model",
      renderHeader: (rows: any) => (
        <div 
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' ,marginLeft: "70px"}}
          onClick={() => handleSort('masterModel')}
        >
          <b>Master Model</b>
          <SortIcon columnName="masterModel" />
        </div>
      ),
      renderCell: (row: any) => {
        if (row?.MasterDeleted === true) {
          return <></>;
        }
        
        const displayName = row?.masterModel?.displayName || '';
        return (
          <>
            {displayName}
          </>
        );
      },
    },
    {
      name: "Brand",
      renderHeader: (rows: any) => (
        <div 
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', paddingLeft: '8px' }}
          onClick={() => handleSort('brandName')}
        >
          <b>Brand</b>
          <SortIcon columnName="brandName" />
        </div>
      ),
      renderCell: (row: any) => (
        <>
          {row && (
            <div style={{ paddingLeft: '8px', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {row.brandName}
            </div>
          )}
        </>
      )
    },

   {
  name: "Master Model Status",
  renderHeader: (rows: any) => (
    <>
      <b>Master Model Status</b>
    </>
  ),
  renderCell: (row: any) => {
    // Check if there are removed products
    const removedProducts = row?.removedproduct || [];
    const hasRemovedProducts = Array.isArray(removedProducts) && removedProducts.length > 0;

    // Check if there are soft deleted products
    const softDeletedCount = row?.softDeletedProducts?.count || 0;
    const hasSoftDeletedProducts = softDeletedCount > 0;

    // Main status badge based on MasterDeleted
    const mainStatusBadge = row?.MasterDeleted === true ? (
      <Badge
        variant="danger"
        className="badge-danger"
      >
        Deleted
      </Badge>
    ) : (
      <Badge
        variant="success"
        className="badge-success"
      >
        Active
      </Badge>
    );

    // Return badges layout
    return (
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        {mainStatusBadge}
        
        {hasRemovedProducts && (
          <Badge
            variant="warning"
            className="badge-warning"
           
          >
            {removedProducts.length} Recently Updated Child Model{removedProducts.length > 1 ? 's' : ''} 
          </Badge>
        )}

        {hasSoftDeletedProducts && (
          <Badge
            variant="danger"
            className="badge-danger"
          >
            {softDeletedCount} Child Model{softDeletedCount > 1 ? 's' : ''} Deleted
          </Badge>
        )}
      </div>
    );
  },
},
    /* {
      name: "Master Model",
      renderHeader: (rows: any) => (
        <>
          <b>Master Models</b>
        </>
      ),
      renderCell: (row: any) => (
        <>
          {Array.isArray(row.ProductInfo) && row.ProductInfo.length > 0
            ? row.ProductInfo.map((item: any) => item.modelNumber).slice(0, 5).join(', ')
            : row.modelNumbers || ''}
        </>
      ),
    }, */
    {
      name: "created_at",
      renderHeader: (rows: any) => (
        <>
          <b>Created At</b>
        </>
      ),
      renderCell: (row: any) => {
        const date = new Date(row.createdAt);
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = String(hours % 12 || 12).padStart(2, '0');
        const formattedMinutes = String(minutes).padStart(2, '0');

        const formattedDate = `${String(date.getDate()).padStart(2, "0")}/${String(
          date.getMonth() + 1
        ).padStart(2, "0")}/${date.getFullYear()} ${formattedHours}:${formattedMinutes} ${ampm}`;

        return <>{formattedDate}</>;
      },
    },
    // {
    //   name: "updated_at",
    //   renderHeader: (rows: any) => (
    //     <>
    //       <b>Updated At</b>
    //     </>
    //   ),
    //   renderCell: (row: any) => {
    //     const date = new Date(row.updatedAt);
    //     const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
    //       date.getDate()
    //     ).padStart(2, "0")} ${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;

    //     return <div className="text-start">{formattedDate}</div>;
    //   },
    // },


    {
      name: "Actions",
      renderHeader: (rows: any) => (
        <>
          <b>Actions</b>
        </>
      ),
      renderCell: (row: any) => <MasterTableAction  product={row} />,
    },
  ];

  // Centralized API call function
  const fetchMasterData = useCallback(async (queryParams: string, isFilter = false) => {
    if (apiCallInProgress.current) return; 
    
    apiCallInProgress.current = true;
    dispatch(setLoading(true));
    
    if (isFilter) {
      setFilterLoading(true);
    }

    try {
      const response = await getMaster(queryParams);
      if (response.data.status) {
        dispatch(setMaster(response.data.data.data)); // Changed to setMaster
         dispatch(setTotalCount(Math.ceil(response.data.data.totalCount)))
        dispatch(setTotalPage(Math.ceil(response.data.data.totalCount / perPage)));
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error("Network Error");
    } finally {
      dispatch(setLoading(false));
      setInitload(false);
      if (isFilter) {
        setFilterLoading(false);
      }
      apiCallInProgress.current = false;
    }
  }, [dispatch, perPage]);

 
  useEffect(() => {
    const searchQuery = `page=${currentPage}&limit=${perPage}&search=${searchTerm}&brand=${brandFilter}&sort=${sortColumn}&sortBy=${sortBy}`;
    fetchMasterData(searchQuery, !initload);
  }, [
    currentPage, 
    perPage, 
    searchTerm, 
    brandFilter, 
    sortColumn, // Added sortColumn
    sortBy, // Added sortBy
    rerender1, 
    fetchMasterData,
    initload
  ]);

 
  useEffect(() => {
    return () => {
      dispatch(setSearchTerm(''));
    };
  }, [dispatch]);

  const handlePageChange = useCallback(
    (value: number) => {
      dispatch(setCurrentPage(value));
    },
    [dispatch]
  );

  const handlePerPageChange = useCallback(
    (value: number) => {
      dispatch(setCurrentPage(1)); // Reset to first page
      dispatch(setPerPage(value));
    },
    [dispatch]
  );

  const handleSearchParams = useCallback(
    (value: string) => {
      dispatch(setCurrentPage(1));
      dispatch(setSearchTerm(value));
    },
    [dispatch]
  );

  const handleBrandFilter = useCallback(
    async (data: any) => {
      let payload = data.map((value: any) => value.brandName).join(","); 
      // Set state
      dispatch(setCurrentPage(1));
      setBrandFilter(payload);
      setFilterLoading(true);
      
      // Manual API call with brand and current sorting
      const searchQuery = `page=1&limit=${perPage}&search=${searchTerm}&brand=${payload}&sort=${sortColumn}&sortBy=${sortBy}`;  
      try {
        const response = await getMaster(searchQuery);
        
        if (response.data.status) {
          dispatch(setMaster(response.data.data.data)); // Changed to setMaster
          dispatch(setTotalPage(Math.ceil(response.data.data.totalCount / perPage)));
        }
      } catch (error) {
        console.error("Manual API Error:", error);
      } finally {
        setFilterLoading(false);
      }
    },
    [dispatch, perPage, searchTerm, sortColumn, sortBy] // Added sortColumn and sortBy
  );

  const configuration: TTableProps = {
    columns: columns,
    data: data, 
    rows: data,
    showPagination: true,
    showSearch: true,
    showPerPage: true,
    paginationData: {
      perPage: perPage,
      currentPage: currentPage,
      totalPage: totalPage,
      totalCount: totalCount
    },
    showFilter: true,
    filters: (
      <div className="d-flex align-items-center gap-3">
        <BrandFilter
          isAccesory={false}
          onBrandFilterChange={handleBrandFilter}
          currentBrandFilter={brandFilter}
        />
      </div>
    ),
    onPageChange: handlePageChange,
    onPerPageChange: handlePerPageChange,
    handleSearchParams: handleSearchParams,
    searchPlaceholder: "Search Products",
    searchLoading: loading || filterloading,
  };

  const navigate = useNavigate();

  const handleMasterAdd = useCallback(() => {
    setAddMasterModel(!addMasterModel);
    if (!addMasterModel) {
      navigate("add");
    }
  }, [addMasterModel, navigate]);

  const handleSelect = (selectedAction: string) => {
    switch (selectedAction) {
      case "Manually":
        navigate("add");
        break;
      case "Add Master Model":
        handleMasterAdd();
        break;
      default:
        break;
    }
  };

  if (loading && initload) {
    return <TableSkeleton rows={10} columns={6} />;
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-5">
        <div className="d-flex align-items-center" style={{ gap: "5px" }}>
          <h2>Master Model </h2>
          <img
            alt="Logo"
            src={toAbsoluteUrl("/media/icons/duotune/art/exclamation-icon.svg")}
            className="h-20px cursor-pointer"
            onClick={() => navigate(`/helps?moduleName=Master`)}
          />
        </div>

        <button
          onClick={handleMasterAdd}
          className="btn btn-light btn-primary btn-xl"
        >
          Add Master Model
        </button>
      </div>

      <MasterList {...configuration} />

      {addMasterModel && (
        <MasterFormModal onClose={() => handleMasterAdd()} />
      )}
    </>
  );
};

export default MasterPage;
